<template>
  <v-layout row justify-center>
    <loadingcomp v-bind:mesaj="' '" v-model="loadingvmodel"></loadingcomp>
    <v-layout row justify-center>
      <v-dialog
        v-model="dialog"
        fullscreen
        transition="dialog-bottom-transition"
        :overlay="false"
      >
        <v-card>
          <v-toolbar dark color="primary">
            <v-btn icon @click.native="dialog = false" dark>
              <v-icon>close</v-icon>
            </v-btn>
            <v-toolbar-title>Şablon Düzenleme</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-toolbar-items>
              <v-btn dark flat @click="saveResult()">Kaydet</v-btn>
            </v-toolbar-items>
          </v-toolbar>

          <v-divider></v-divider>
          <v-layout row wrap>
            <v-flex xs12 sm12 md8 pt-1>
              <v-layout row wrap>
                <v-flex xs12 sm12 md12 pa-2>
                  <v-card>
                    <v-card-text>
                      <v-layout row wrap>
                        <v-flex
                          xs6
                          sm4
                          md3
                          v-for="(itemPick, ind) in resultList"
                          :key="ind"
                          class="text-xs-center"
                          px-2
                        >
                          <v-btn
                            v-if="ind == 0"
                            color="blue-grey"
                            class="white--text"
                            block
                            pa-2
                            @click="deletePickData(itemPick)"
                          >
                            {{ itemPick.text }}
                          </v-btn>

                          <v-btn
                            @click="deletePickData(itemPick)"
                            v-if="ind > 0"
                            color="blue-grey"
                            class="white--text"
                            block
                            pa-2
                          >
                            <v-icon left :color="itemPick.iconColor">{{
                              itemPick.iconName
                            }}</v-icon>

                            {{ itemPick.text }}
                          </v-btn>
                        </v-flex>
                      </v-layout>
                    </v-card-text>
                  </v-card>
                </v-flex>
                <v-flex
                  xs2
                  sm3
                  md3
                  pa-2
                  v-for="item in items"
                  v-bind:key="item.FieldID"
                >
                  <v-btn
                    block
                    color="green"
                    :disabled="pickWait || item.selected"
                    outline
                    @click="setPickData(item.FieldID)"
                    >{{ item.FieldName }}</v-btn
                  >
                </v-flex>
              </v-layout>
            </v-flex>
            <v-flex xs12 sm4 md4 pt-2>
              <v-layout row wrap>
                <v-flex xs12 sm12 md6 pa-2>
                  <v-btn
                    block
                    outline
                    :disabled="!pickWait"
                    color="primary"
                    @click="pickData(1, pickDataValue)"
                  >
                    <v-icon>add</v-icon>
                  </v-btn>
                </v-flex>
                <v-flex xs12 sm12 md6 pa-2>
                  <v-btn
                    block
                    outline
                    :disabled="!pickWait"
                    color="error"
                    @click="pickData(2, pickDataValue)"
                  >
                    <v-icon>remove</v-icon>
                  </v-btn>
                </v-flex>
                <v-flex xs12 sm12 md12 pa-2>
                  <v-btn
                    block
                    outline
                    color="info"
                    @click.native="deleteDialog = true"
                  >
                    <v-icon>clear</v-icon>
                  </v-btn>
                </v-flex>

                <v-flex xs12 sm12 md12 pa-2>
                  <v-layout row wrap>
                    <v-flex xs12 sm6 md6>
                      <v-text-field
                        label="Satır Başlığı"
                        v-model="LineTitle"
                      ></v-text-field>
                    </v-flex>
                    <v-flex xs12 sm6 md6>
                      <v-text-field
                        v-model="RecieptExplain"
                        label="Fiş Satır Açıklama"
                      ></v-text-field>
                    </v-flex>
                    <v-flex xs12 sm6 md6>
                      <v-radio-group v-model="deptCredit" row>
                        <v-radio label="Borç" :value="false"></v-radio>
                        <v-radio label="Alacak" :value="true"></v-radio>
                      </v-radio-group>
                    </v-flex>
                  </v-layout>
                </v-flex>
              </v-layout>
            </v-flex>
          </v-layout>
        </v-card>
      </v-dialog>
    </v-layout>

    <v-layout row justify-center>
      <v-dialog v-model="deleteDialog" persistent max-width="500px">
        <v-card>
          <v-card-title>
            <span class="headline">Tümünü Sil</span>
          </v-card-title>
          <v-card-text>
            <v-layout wrap> Silmek istediğinize emin misiniz ? </v-layout>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              color="blue darken-1"
              flat
              @click.native="deleteDialog = false"
              >Kapat</v-btn
            >
            <v-btn color="blue darken-1" flat @click="clearAll()">Sil</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-layout>
  </v-layout>
</template>

<script>
import auth from "@/api/auth";
import loadingcomp from "@/components/app/customcomp/loadingcomp";

export default {
  props: {
    value: {},
    status: {},
    lineID: {},
  },
  computed: {
    val: {
      get: function () {
        return this.value;
      },
      set: function (newValue) {
        this.$emit("input", newValue);
      },
    },
  },
  data() {
    return {
      deleteDialog: false,
      LineTitle: null,
      RecieptExplain: null,
      deptCredit: false,
      update: false,
      offsetTop: 0,
      loadingvmodel: false,
      sendText: null,
      menu: false,
      resultList: [],
      result: null,
      selectedFieldId: 0,
      dialog: false,
      pickDataValue: 0,
      searchParams: {
        FieldID: 0,
        FieldName: null,
        FieldDBName: null,
        FieldDB: 1, // 1 : Bilet, 2: Cari, 3: Coper
        FieldTableName: null,
        TemplateType: 1,
      },
      items: [],
      pickWait: false,
    };
  },
  methods: {
    deletePickData(val) {
      var fieldIndex = this.resultList.findIndex((x) => x.value == val.value);
      if (fieldIndex > -1) {
        var fieldAll = this.items.find((x) => x.FieldID == val.value);
        fieldAll.selected = false;
        this.resultList.splice(fieldIndex, 1);
        this.pickWait = false;
        this.pickDataValue = -1;
      }
    },
    setPickData(val) {
      this.pickDataValue = val;
      this.pickWait = true;
    },
    setTemplateType(templateType) {
      this.searchParams.TemplateType = templateType;
    },
    openUpdateDialog(params) {
      this.resultList = [];
      this.items = [];
      this.$http
        .post(
          auth.API_URL +
            "api/AccountingIntegrations/IntegrationTemplateLineLoad",
          params,
          {
            headers: {
              Authorization: "Bearer " + auth.getAuthHeader(),
            },
          }
        )
        .then(
          (response) => {
            // eslint-disable-next-line no-useless-escape
            var separators = ["\\+", "-", "\\*", "\\?"];
            var tokens = response.body.LineScript.split(
              new RegExp(separators.join("|"), "g")
            );
            this.deptCredit = response.body.DeptCredit;
            this.RecieptExplain = response.body.RecieptExplain;
            this.LineTitle = response.body.LineTitle;
            this.getListforUpdate(tokens, response.body.LineScript);
          },
          (response) => {
            if (response.status === 0) {
              this.text1 = "Service Unavailable-IntegrationTemplateLineLoad";
              this.snackbar = true;
              this.loadingvmodel = false;
            } else {
              this.text1 = "Service Unavailable-IntegrationTemplateLineLoad";
              this.snackbar = true;
              this.loadingvmodel = false;
            }
          }
        );
    },
    onScroll(e) {
      this.offsetTop = e.target.scrollTop;
    },
    clearAll() {
      this.resultList = [];
      this.items.forEach((element) => {
        element.selected = false;
      });
      this.pickWait = false;
      this.deleteDialog = false;
    },
    saveResult() {
      this.sendText = null;
      this.resultList.forEach((element) => {
        if (element.iconName == "remove") {
          if (this.sendText == undefined) {
            this.sendText = element.text;
          } else {
            this.sendText = this.sendText + "-" + element.text;
          }
        } else {
          if (this.sendText == undefined) {
            this.sendText = element.text;
          } else {
            this.sendText = this.sendText + "+" + element.text;
          }
        }
      });

      var data = {
        text: this.sendText,
        deptCredit: this.deptCredit,
        RecieptExplain: this.RecieptExplain,
        LineTitle: this.LineTitle,
      };

      if (this.update) {
        this.$emit("updateResult", data);
      } else {
        this.$emit("saveResult", data);
      }

      this.dialog = false;
    },
    pickData(key, kod) {
      switch (key) {
        case 1:
          var fieldNameAdd = this.items.find((x) => x.FieldID == kod);
          fieldNameAdd.selected = true;
          var resultAdd = {
            iconColor: "green",
            iconName: "add",
            text: fieldNameAdd.FieldName,
            value: kod,
          };
          this.resultList.push(resultAdd);
          this.pickWait = false;
          this.pickDataValue = -1;

          break;
        case 2:
          var fieldNameRemove = this.items.find((x) => x.FieldID == kod);
          fieldNameRemove.selected = true;
          var resultRemove = {
            iconColor: "red",
            iconName: "remove",
            text: fieldNameRemove.FieldName,
            value: kod,
          };
          this.resultList.push(resultRemove);
          this.pickWait = false;
          this.pickDataValue = -1;
          break;
        case 3:
          var fieldIndex = this.resultList.findIndex((x) => x.value == kod);
          if (fieldIndex > -1) {
            var fieldAll = this.items.find((x) => x.FieldID == kod);
            fieldAll.selected = false;
            this.resultList.splice(fieldIndex, 1);
            this.pickWait = false;
            this.pickDataValue = -1;
          }

          break;
        default:
          break;
      }
    },
    openDialog() {
      this.update = false;
      this.loadingvmodel = true;
      this.items = [];
      this.resultList = [];
      this.getList();
    },
    getListforUpdate(value, list) {
      this.update = true;
      this.$http
        .post(
          auth.API_URL + "api/AccountingIntegrations/IntegrationFieldList",
          this.searchParams,
          {
            headers: {
              Authorization: "Bearer " + auth.getAuthHeader(),
            },
          }
        )
        .then(
          (response) => {
            response.body.forEach((element) => {
              var newElement = {
                ...element,
                selected: false,
              };
              this.items.push(newElement);
            });

            value.forEach((element) => {
              var fieldNameRemove = this.items.find(
                (x) => x.FieldName == element
              );

              var iconSettingsToken = list.indexOf(fieldNameRemove.FieldName);

              if (iconSettingsToken != -1) {
                var iconStatus = list.substring(
                  iconSettingsToken - 1,
                  iconSettingsToken
                );
                var iconParam = {
                  color: null,
                  name: null,
                };

                if (iconStatus == "-") {
                  iconParam.color = "red";
                  iconParam.name = "remove";
                } else if (iconStatus == "+") {
                  iconParam.color = "green";
                  iconParam.name = "add";
                } else {
                  iconParam.color = "";
                  iconParam.name = "";
                }
              }

              fieldNameRemove.selected = true;
              var resultRemove = {
                iconColor: iconParam.color,
                iconName: iconParam.name,
                text: fieldNameRemove.FieldName,
                value: fieldNameRemove.FieldID,
              };
              this.resultList.push(resultRemove);
            });

            this.dialog = true;
            this.loadingvmodel = false;
          },
          (response) => {
            if (response.status === 0) {
              this.text1 = "Service Unavailable-IntegrationTemplateLineLoad";
              this.snackbar = true;
              this.loadingvmodel = false;
            } else {
              this.text1 = "Service Unavailable-IntegrationTemplateLineLoad";
              this.snackbar = true;
              this.loadingvmodel = false;
            }
          }
        );
    },
    getList() {
      this.$http
        .post(
          auth.API_URL + "api/AccountingIntegrations/IntegrationFieldList",
          this.searchParams,
          {
            headers: {
              Authorization: "Bearer " + auth.getAuthHeader(),
            },
          }
        )
        .then(
          (response) => {
            response.body.forEach((element) => {
              var newElement = {
                ...element,
                selected: false,
              };
              this.items.push(newElement);
            });

            this.dialog = true;
            this.loadingvmodel = false;
          },
          (response) => {
            if (response.status === 0) {
              this.text1 = "Service Unavailable-IntegrationTemplateLineLoad";
              this.snackbar = true;
              this.loadingvmodel = false;
            } else {
              this.text1 = "Service Unavailable-IntegrationTemplateLineLoad";
              this.snackbar = true;
              this.loadingvmodel = false;
            }
          }
        );
    },
  },
  components: {
    loadingcomp,
  },
};
</script>

<style scoped>
.rounded-corner {
  border-start-end-radius: 20px;
  border-end-start-radius: 20px;
}
</style>
